import {useEffect, useRef, useState} from "react";

import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS, UNLOCK_CHOICE_LOADER_DELAY_MS} from "../../../constants/unlock_choice_timeouts";
import {useUnlockChoiceData} from "../../../hooks/use_unlock_choice_data";
import {useUnlockChoiceExperiment} from "../../../hooks/use_unlock_choice_experiment";
import {UnlockChoiceDecision} from "../../../state/registration_flow_slice";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint, UnlockChoiceOrigin} from "../../../types/UnlockChoiceEntryPoint";
import {isUnlockChoiceEligible} from "../../../utils/is_unlock_choice_eligible";
import {UnlockChoiceModal} from "./UnlockChoiceModal";

interface IProps {
    entryPoint?: UnlockChoiceEntryPoint;
    origin?: UnlockChoiceOrigin;
    decision: UnlockChoiceDecision | null;
    propertyId?: number;
    offerId?: number;
    zIndex?: number;
    onLegacyStep: () => void;
    onUnavailable: () => void;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onFinishedWithoutLead: () => void;
    onClose: () => void;
}

export const UnlockChoiceStep = (props: IProps) => {
    const {entryPoint, origin, decision, propertyId, offerId, zIndex, onLegacyStep, onUnavailable, onLeadSent, onFinishedWithoutLead, onClose} = props;
    const isDecidedBeforeStep = origin === "cta" || decision !== null;
    const onDecidedUnavailable = decision !== null && entryPoint !== UnlockChoiceEntryPoint.LEAD ? onLegacyStep : onUnavailable;
    const isModalAllowed = decision !== "control" && entryPoint !== undefined && isUnlockChoiceEligible(entryPoint, {propertyId, offerId});
    const {isLoading: isDataLoading, data} = useUnlockChoiceData({entryPoint, isEnabled: isModalAllowed});
    const isEligible = isModalAllowed && data !== null;
    const isIneligible = !isModalAllowed || (!isDataLoading && data === null);
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: isEligible && !isDecidedBeforeStep});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const [treatmentData, setTreatmentData] = useState<IUnlockChoiceData | null>(null);
    const hasDecidedRef = useRef(false);
    const isPending = !isIneligible && !(isEligible && (isDecidedBeforeStep || isResolved));
    const isLoadingDecidedData = isDecidedBeforeStep && isDataLoading;
    const [isLoaderDelayOver, setIsLoaderDelayOver] = useState(false);

    useEffect(() => {
        if (!isPending) {
            return;
        }

        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, [isPending]);

    useEffect(() => {
        if (!isLoadingDecidedData) {
            return;
        }

        const timeoutId = setTimeout(() => setIsLoaderDelayOver(true), UNLOCK_CHOICE_LOADER_DELAY_MS);

        return () => clearTimeout(timeoutId);
    }, [isLoadingDecidedData]);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isDecidedBeforeStep) {
            if (isEligible) {
                hasDecidedRef.current = true;
                setTreatmentData(data);
                return;
            }

            if (isIneligible || hasTimedOut) {
                hasDecidedRef.current = true;
                onDecidedUnavailable();
            }

            return;
        }

        if (isEligible && isResolved) {
            hasDecidedRef.current = true;
            trackExposure();

            if (isTreatment) {
                setTreatmentData(data);
                return;
            }

            onLegacyStep();
            return;
        }

        if (isIneligible || hasTimedOut) {
            hasDecidedRef.current = true;
            onLegacyStep();
        }
    }, [isDecidedBeforeStep, isEligible, isIneligible, isResolved, isTreatment, hasTimedOut]);

    if (entryPoint === undefined || (treatmentData === null && !isLoaderDelayOver)) {
        return null;
    }

    return (
        <UnlockChoiceModal
            entryPoint={entryPoint}
            data={treatmentData}
            zIndex={zIndex}
            onLeadSent={onLeadSent}
            onFinishedWithoutLead={onFinishedWithoutLead}
            onClose={onClose}
        />
    );
};
import {useEffect, useRef, useState} from "react";

import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS, UNLOCK_CHOICE_LOADER_DELAY_MS} from "../../../constants/unlock_choice_timeouts";
import {useUnlockChoiceData} from "../../../hooks/use_unlock_choice_data";
import {useUnlockChoiceExperiment} from "../../../hooks/use_unlock_choice_experiment";
import {UnlockChoiceDecision} from "../../../state/registration_flow_slice";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint, UnlockChoiceOrigin} from "../../../types/UnlockChoiceEntryPoint";
import {isUnlockChoiceEligible} from "../../../utils/is_unlock_choice_eligible";
import {UnlockChoiceModal} from "./UnlockChoiceModal";

interface IProps {
    entryPoint?: UnlockChoiceEntryPoint;
    origin?: UnlockChoiceOrigin;
    decision: UnlockChoiceDecision | null;
    propertyId?: number;
    offerId?: number;
    zIndex?: number;
    onLegacyStep: () => void;
    onUnavailable: () => void;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onFinishedWithoutLead: () => void;
    onClose: () => void;
}

export const UnlockChoiceStep = (props: IProps) => {
    const {entryPoint, origin, decision, propertyId, offerId, zIndex, onLegacyStep, onUnavailable, onLeadSent, onFinishedWithoutLead, onClose} = props;
    const isDecidedBeforeStep = origin === "cta" || decision !== null;
    const onDecidedUnavailable = decision !== null && entryPoint !== UnlockChoiceEntryPoint.LEAD ? onLegacyStep : onUnavailable;
    const isModalAllowed = decision !== "control" && entryPoint !== undefined && isUnlockChoiceEligible(entryPoint, {propertyId, offerId});
    const {isLoading: isDataLoading, data} = useUnlockChoiceData({entryPoint, isEnabled: isModalAllowed});
    const isEligible = isModalAllowed && data !== null;
    const isIneligible = !isModalAllowed || (!isDataLoading && data === null);
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: isEligible && !isDecidedBeforeStep});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const [treatmentData, setTreatmentData] = useState<IUnlockChoiceData | null>(null);
    const hasDecidedRef = useRef(false);
    const isPending = !isIneligible && !(isEligible && (isDecidedBeforeStep || isResolved));
    const isLoadingDecidedData = isDecidedBeforeStep && isDataLoading;
    const [isLoaderDelayOver, setIsLoaderDelayOver] = useState(false);

    useEffect(() => {
        if (!isPending) {
            return;
        }

        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, [isPending]);

    useEffect(() => {
        if (!isLoadingDecidedData) {
            return;
        }

        const timeoutId = setTimeout(() => setIsLoaderDelayOver(true), UNLOCK_CHOICE_LOADER_DELAY_MS);

        return () => clearTimeout(timeoutId);
    }, [isLoadingDecidedData]);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isDecidedBeforeStep) {
            if (isEligible) {
                hasDecidedRef.current = true;
                setTreatmentData(data);
                return;
            }

            if (isIneligible || hasTimedOut) {
                hasDecidedRef.current = true;
                onDecidedUnavailable();
            }

            return;
        }

        if (isEligible && isResolved) {
            hasDecidedRef.current = true;
            trackExposure();

            if (isTreatment) {
                setTreatmentData(data);
                return;
            }

            onLegacyStep();
            return;
        }

        if (isIneligible || hasTimedOut) {
            hasDecidedRef.current = true;
            onLegacyStep();
        }
    }, [isDecidedBeforeStep, isEligible, isIneligible, isResolved, isTreatment, hasTimedOut]);

    if (entryPoint === undefined || (treatmentData === null && !isLoaderDelayOver)) {
        return null;
    }

    return (
        <UnlockChoiceModal
            entryPoint={entryPoint}
            data={treatmentData}
            zIndex={zIndex}
            onLeadSent={onLeadSent}
            onFinishedWithoutLead={onFinishedWithoutLead}
            onClose={onClose}
        />
    );
};
